import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      gray: { gray20 },
      primary: { primaryBlue3 },
      whiteOpacity92,
    },
  } = styleConfig;

  return {
    button: {
      color: primaryBlue3,
      width: '140',
    },
    leftIcon: {
      color: gray20,
      marginRight: '10px',
      width: '26px',
      height: '26px',
    },
    buttonWrapper: {
      justifyContent: 'space-between',
      width: '100%',
      display: 'flex',
      margin: '20px 0 0 0',
    },
    // waterMark: {
    //   display: 'none',
    //   visibility: 'visible',
    // },
    paperStyle: {
      backgroundColor: whiteOpacity92,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  };
};

export default styles;
